/* tia-buy-box.js: the product buy box's script, lifted out of snippets/tia-cp-buy-box.liquid
   on 2026-09-17 (seo-content/pdp-speed-2026-09-17) to be cached across product pages. The
   snippet renders the form, the variants island and the CSS; this file boots on [data-tia-buy]
   and exposes window.tiaBuyBoxInit for the layout's InstantClick hook. */
  (function () {
    function init() {
    var root = document.querySelector('[data-tia-buy]');
    if (!root || root.dataset.tiaInit === '1') return;
    root.dataset.tiaInit = '1';
    var dataEl = document.querySelector('[data-tia-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var form = root.querySelector('.tia-buy__form');
    var idInput = root.querySelector('[data-tia-id]');
    // price and button live in the server-rendered band (tia-buy-band.liquid), a
    // sibling of this root further down the column — resolve them document-wide
    var priceOut = document.querySelector('[data-tia-band] [data-tia-price]');
    var promoPrice = root.querySelector('[data-tia-promo-price]');
    var promoWas = root.querySelector('[data-tia-promo-was]');
    var promoPrices = root.querySelector('[data-tia-promo-prices]');
    var priceFrom = document.querySelector('[data-tia-band] [data-tia-from]');
    var atcBtn = document.querySelector('[data-tia-band] [data-tia-atc]');
    var atcText = document.querySelector('[data-tia-band] [data-tia-atc-text]');
    var atcSub = document.querySelector('[data-tia-band] [data-tia-atc-sub]');
    // Delivery promise under the price (growth plan C2, 2026-10-15): the band renders the line for
    // the first paint; this keeps it true to the selected layout. 1 Piece and 1 Vertical are a single
    // canvas, every other layout is a set. The option index comes from data-tia-optnames.
    var deliveryOut = document.querySelector('[data-tia-band] [data-tia-delivery], .tia-buy--tee [data-tia-delivery]');
    var layoutIdx = -1;
    try {
      var optNames = JSON.parse(root.getAttribute('data-tia-optnames') || '[]');
      for (var oi = 0; oi < optNames.length; oi++) { if (optNames[oi] === 'Layout' || optNames[oi] === 'Pieces') { layoutIdx = oi; break; } }
    } catch (e) { layoutIdx = -1; }
    function syncDelivery(v) {
      if (!deliveryOut || !v || layoutIdx < 0) return;
      var lay = v.o[layoutIdx];
      var single = (lay === '1 Piece' || lay === '1 Vertical');
      var txt = deliveryOut.getAttribute(single ? 'data-single' : 'data-multi') || '';
      if (deliveryOut.textContent !== txt) deliveryOut.textContent = txt;
      deliveryOut.hidden = !txt;
    }
    var promoPct = parseFloat(root.getAttribute('data-promo-percent')) || 0;
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    // The header promo bar is the single source of truth for the sale. It rotates
    // daily (Weekend Sale, Friday Sale, BFCM...), so parse label, percent and code out
    // of its text and override the section settings. If any piece fails to parse the
    // Liquid-rendered fallbacks stay as they are.
    (function hydrateFromHeaderPromo() {
      var promoBox = root.querySelector('[data-tia-promo]');
      if (!promoBox) return;
      var src = document.querySelector('.tia-hdr__promo');
      if (!src) return;
      var text = (src.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      var pctMatch = text.match(/(\d{1,2})\s*%/);
      var codeMatch = text.match(/CODE\s*:?\s*([A-Z0-9]{3,})/i);
      var labelMatch = text.split(/[!|\u00B7\u2022:]/)[0]
        .replace(/[-\u2013,]?\s*(extra\s*)?\d.*$/i, '').trim();

      if (pctMatch) {
        promoPct = parseFloat(pctMatch[1]);
        var off = root.querySelector('[data-tia-promo-off]');
        if (off) off.textContent = pctMatch[1] + '% OFF';
      }
      if (codeMatch) {
        var codeBtn = root.querySelector('[data-tia-copy]');
        var codeTxt = root.querySelector('[data-tia-promo-codetext]');
        if (codeBtn) codeBtn.setAttribute('data-tia-copy', codeMatch[1].toUpperCase());
        if (codeTxt) codeTxt.textContent = codeMatch[1].toUpperCase();
      }
      if (labelMatch && labelMatch.length >= 3 && labelMatch.length <= 40) {
        var lbl = root.querySelector('[data-tia-promo-label]');
        if (lbl) lbl.textContent = labelMatch;
      }
    })();

    function formatMoney(cents) {
      var val = (cents / 100).toFixed(2);
      var parts = val.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var noDec = parts[0];
      var withDec = parts.join('.');
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, withDec);
    }

    function groups() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-tia-opt]'));
    }
    // the Size axis, matched the way the Liquid and tia-pdp-geometry.js axes() match it
    var sizeIdx = -1;
    groups().forEach(function (g, gi) {
      var nm = g.getAttribute('data-tia-optname') || '';
      if (nm.indexOf('size') > -1 || nm.indexOf('dimension') > -1) sizeIdx = gi;
    });
    function sizeOpen(sel) { return sizeIdx > -1 && sel[sizeIdx] === null; }
    // lowest available price among the variants sharing every NON-size pick
    function lowestFor(sel) {
      var best = null;
      variants.forEach(function (x) {
        if (!x.a) return;
        for (var j = 0; j < sel.length; j++) {
          if (j === sizeIdx || sel[j] === null) continue;
          if (x.o[j] !== sel[j]) return;
        }
        if (best === null || x.p < best) best = x.p;
      });
      return best;
    }
    function picked() {
      // current selection per option index, from the checked radios
      return groups().map(function (g) {
        var r = g.querySelector('input:checked');
        return r ? r.value : null;
      });
    }
    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && variants[i].o[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    // Cascade filter: a value stays visible if some available variant matches it plus
    // the picks in the groups ABOVE it only (Pieces -> Frame Option -> Size). Filtering
    // never flows upward, so the first group always shows everything and no choice can
    // strand the buyer in an unreachable state.
    function refreshDisabled() {
      var sel = picked();
      groups().forEach(function (g, gi) {
        var radios = g.querySelectorAll('input[type="radio"]');
        Array.prototype.forEach.call(radios, function (r) {
          var exists = variants.some(function (v) {
            if (!v.a) return false;
            if (v.o[gi] !== r.value) return false;
            for (var j = 0; j < gi; j++) {
              if (sel[j] !== null && v.o[j] !== sel[j]) return false;
            }
            return true;
          });
          if (exists) r.removeAttribute('data-tia-off');
          else r.setAttribute('data-tia-off', '');
        });
      });
    }

    // The gallery is built by the theme's DEFERRED scripts, but this script runs during
    // parse — on a ?variant= landing the first sync would fire before Flickity exists
    // and do nothing. So: keep driving the MAIN carousel with a backoff until it
    // reports the right cell as selected, and abort if the shopper picks a different
    // variant mid-retry. Success is judged on the main carousel only — the thumb strip
    // marks its own cells is-selected, which is how a thumb-click approach
    // false-positived.
    var galleryTarget = 0;
    function syncGallery(mediaId) {
      if (!mediaId) return;
      galleryTarget = mediaId;
      var attempts = 0;
      (function go() {
        if (galleryTarget !== mediaId) return;
        var main = document.querySelector('.js-product-section--product [data-product-gallery]')
                || document.querySelector('[data-product-gallery]');
        if (main) {
          var target = main.querySelector('.gallery-cell[data-media-id="' + mediaId + '"]');
          if (target && target.classList.contains('is-selected')) return;
          var f = window.Flickity && window.Flickity.data ? window.Flickity.data(main) : null;
          if (target && f) {
            var cells = main.querySelectorAll('.gallery-cell');
            var idx = Array.prototype.indexOf.call(cells, target);
            if (idx > -1) f.select(idx, false, true);
            if (target.classList.contains('is-selected')) return;
          }
        }
        attempts++;
        if (attempts < 12) setTimeout(go, 250 + attempts * 250);
      })();
    }

    function apply(changedIndex) {
      var sel = picked();
      var v = findVariant(sel);

      if (!v && changedIndex !== undefined && changedIndex !== sizeIdx && sizeIdx > -1 && sel[sizeIdx] !== null) {
        // Layout or finish just changed and the chosen size does not exist there. The size is
        // OPEN again (owner 2026-09-17: never pick a size for the shopper), not swapped for the
        // nearest one; the gallery goes back to the largest size and the button asks again.
        var szRadio = groups()[sizeIdx].querySelector('input:checked');
        if (szRadio) szRadio.checked = false;
        sel = picked();
        v = findVariant(sel);
      }

      if (!v && changedIndex !== undefined) {
        // The picked combo does not exist. Keep the value the user just chose and
        // move the other options to the closest combo that does exist.
        var keep = sel[changedIndex];
        var candidates = variants.filter(function (x) { return x.o[changedIndex] === keep && x.a; });
        if (!candidates.length) candidates = variants.filter(function (x) { return x.o[changedIndex] === keep; });
        if (candidates.length) {
          var best = candidates[0], bestScore = -1;
          candidates.forEach(function (c) {
            var s = 0;
            for (var j = 0; j < sel.length; j++) { if (c.o[j] === sel[j]) s++; }
            if (s > bestScore) { bestScore = s; best = c; }
          });
          v = best;
          groups().forEach(function (g, gi) {
            if (gi === sizeIdx && sel[sizeIdx] === null) return;   // an open size stays open
            var r = g.querySelector('input[value="' + CSS.escape(v.o[gi]) + '"]');
            if (r) r.checked = true;
          });
        }
      }
      if (!v) return;

      if (sizeOpen(picked())) {
        // No size chosen: nothing to post. `v` is the first variant of this layout and finish,
        // which is what the old gallery's media and the cascade need; the price reads "From" the
        // lowest of that layout and finish; the button asks for the size; ?variant= comes off the
        // URL so a copied link lands open too. The v2 gallery reads the radios itself.
        var from = lowestFor(picked());
        idInput.value = '';
        if (priceOut && from !== null) priceOut.textContent = formatMoney(from);
        if (priceFrom) priceFrom.hidden = false;
        if (promoPrices) promoPrices.hidden = true;
        if (atcBtn) { atcBtn.disabled = false; atcBtn.setAttribute('data-tia-open', ''); }
        if (atcText) atcText.textContent = atcText.getAttribute('data-label-add') || atcText.textContent;
        if (atcSub) atcSub.textContent = atcSub.getAttribute('data-label-choose') || 'Choose size';
        syncDelivery(v);
        refreshDisabled();
        syncGallery(v.m);
        if (window.history && history.replaceState) {
          var openUrl = new URL(window.location.href);
          if (openUrl.searchParams.has('variant')) {
            openUrl.searchParams.delete('variant');
            history.replaceState({}, '', openUrl.toString());
          }
        }
        return;
      }

      idInput.value = v.id;
      if (priceFrom) priceFrom.hidden = true;
      if (promoPrices) promoPrices.hidden = false;
      if (atcBtn) atcBtn.removeAttribute('data-tia-open');
      if (priceOut) priceOut.textContent = formatMoney(v.p);
      if (promoPrice) promoPrice.textContent = formatMoney(Math.round(v.p * (1 - promoPct / 100)));
      if (promoWas) promoWas.textContent = formatMoney(v.p);

      if (atcBtn) {
        atcBtn.disabled = !v.a;
        if (atcText) atcText.textContent = v.a ? atcText.getAttribute('data-label-add') : atcText.getAttribute('data-label-out');
      }
      if (atcSub) atcSub.textContent = v.o[v.o.length - 1];
      syncDelivery(v);
      refreshDisabled();
      syncGallery(v.m);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    if (atcText) {
      atcText.setAttribute('data-label-add', atcText.textContent.trim());
      atcText.setAttribute('data-label-out', 'Sold Out');
    }

    groups().forEach(function (g, gi) {
      g.addEventListener('change', function () { apply(gi); });
    });

    // copy the promo code, confirm inline for a moment
    var copyBtn = root.querySelector('[data-tia-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-tia-copy');
        var label = copyBtn.querySelector('.tia-buy__promo-code-text');
        var done = function () {
          if (!label) return;
          var prev = label.innerHTML;
          label.innerHTML = 'COPIED <strong>' + code + '</strong>';
          setTimeout(function () { label.innerHTML = prev; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else { done(); }
      });
    }

    // Add to Cart with no size: do not post, take the shopper to the size row and pulse it once.
    // The band's button submits this form via form="tia-buy-form"; preventDefault on its click
    // stops the submit, and the submit guard below catches every other route to a post (the
    // sticky bar clicks this same button, so it lands here too). No size, no variant, no post.
    function askForSize(ev) {
      if (!sizeOpen(picked())) return false;
      if (ev) ev.preventDefault();
      var g = groups()[sizeIdx];
      if (!g) return true;
      g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      g.classList.remove('tia-buy__opt--nudge');
      void g.offsetWidth;                                    // restart the animation on a second click
      g.classList.add('tia-buy__opt--nudge');
      try { g.focus({ preventScroll: true }); } catch (e) { g.focus(); }
      return true;
    }
    if (atcBtn) atcBtn.addEventListener('click', askForSize);
    if (form) {
      form.addEventListener('submit', function (ev) {
        if (askForSize(ev)) return;
        if (atcBtn && atcText) { atcText.textContent = 'Adding...'; atcBtn.setAttribute('aria-busy', 'true'); }
      });
    }

    /* ---- inches / cm, DISPLAY ONLY (ported from the tia-pdp-new prototype) ----
       The radio `value` is never touched: it is the string that posts to /cart/add and
       the string tia-pdp-accordion, tia-size-chart and sticky-atc parse to resolve the
       variant. Only the visible label on the <label> changes, and the inch original is
       kept in data-tia-in so the conversion is reversible rather than lossy.
       Nothing else in this file rewrites chip text (refreshDisabled only toggles
       data-tia-off on the radios), so a converted label survives every redraw. */
    var unitBtn = root.querySelector('[data-tia-unit]');
    if (unitBtn) {
      /* Chips go COMPACT in cm ("61 \u00D7 41", no unit per chip) and the unit is stated
         ONCE in the group heading ("Size (cm)") -- the exact pattern the customizer uses,
         matched on owner instruction 2026-08-30. */
      var toCm = function (txt) {
        var m = String(txt).match(/(\d+(?:\.\d+)?)\D+(\d+(?:\.\d+)?)/);
        if (!m) return null;
        return Math.round(parseFloat(m[1]) * 2.54) + ' \u00D7 ' + Math.round(parseFloat(m[2]) * 2.54);
      };
      var paintUnit = function () {
        var isCm = root.getAttribute('data-tia-unit') === 'cm';
        Array.prototype.forEach.call(root.querySelectorAll('[data-tia-in]'), function (el) {
          var inches = el.getAttribute('data-tia-in');
          el.textContent = isCm ? (toCm(inches) || inches) : inches;
        });
        var lbl = root.querySelector('[data-tia-optlabel]');
        if (lbl) lbl.textContent = lbl.getAttribute('data-tia-optlabel') + (isCm ? ' (cm)' : '');
        unitBtn.textContent = isCm ? 'show inches' : 'show cm';
      };
      unitBtn.addEventListener('click', function () {
        var next = root.getAttribute('data-tia-unit') === 'cm' ? 'in' : 'cm';
        root.setAttribute('data-tia-unit', next);
        paintUnit();
        try { localStorage.setItem('tiaUnit', next); } catch (e) {}
        /* The scale preview echoes the same measurement, so it has to hear this. */
        document.dispatchEvent(new CustomEvent('tia:unit', { detail: { unit: next } }));
      });
      try { if (localStorage.getItem('tiaUnit') === 'cm') root.setAttribute('data-tia-unit', 'cm'); } catch (e) {}
      paintUnit();
    }

    /* ---- per-size chip prices: the available variant matching this size plus the
       current picks of every OTHER group. Repainted on every change so a layout or
       finish switch reprices the whole row. ---- */
    function paintSizePrices() {
      var out = root.querySelectorAll('[data-tia-sizeprice]');
      if (!out.length) return;
      var gs = groups(), sel = picked();
      var szIdx = -1;
      gs.forEach(function (g, gi) {
        var nm = g.getAttribute('data-tia-optname') || '';
        if (nm.indexOf('size') > -1 || nm.indexOf('dimension') > -1) szIdx = gi;
      });
      if (szIdx === -1) return;
      Array.prototype.forEach.call(out, function (el) {
        var val = el.getAttribute('data-tia-sizeprice'), hit = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v.a || v.o[szIdx] !== val) continue;
          var ok = true;
          for (var j = 0; j < sel.length; j++) {
            if (j === szIdx) continue;
            if (sel[j] !== null && v.o[j] !== sel[j]) { ok = false; break; }
          }
          if (ok) { hit = v; break; }
        }
        el.textContent = hit ? formatMoney(hit.p) : '';
      });
    }
    if (form) form.addEventListener('change', function () { setTimeout(paintSizePrices, 0); });
    paintSizePrices();

    /* ---- layout tiles: draw each value's real panel arrangement with the size chart's
       own geometry engine. The asset is deferred, so retry briefly; without it the
       tiles stay clean text. ---- */
    function drawLayoutTiles() {
      var boxes = root.querySelectorAll('[data-tia-lay]');
      if (!boxes.length) return true;
      var G = window.TiaPdpGeo;
      if (!G) return false;
      var names;
      try { names = JSON.parse(root.getAttribute('data-tia-optnames') || '[]'); }
      catch (e) { return true; }
      var built = G.buildLive(names, variants.map(function (v) { return v.o; }));
      if (!built.live.length) return true;
      Array.prototype.forEach.call(boxes, function (lab) {
        var val = lab.getAttribute('data-tia-lay');
        var box = lab.querySelector('.tia-buy__laybox');
        if (!box || box.childNodes.length) return;
        var entry = built.live.filter(function (e) { return e.l.opt === val && e.l.mat === 'Canvas Print'; })[0] ||
                    built.live.filter(function (e) { return e.l.opt === val; })[0];
        if (!entry) return;
        var sz = entry.sizes[Math.min(1, entry.sizes.length - 1)];
        var P = G.panels(entry.l, sz), aW = G.DW(sz), aH = G.DH(sz);
        var ar = aW / aH, tw = 64, th = 40, bw, bh;
        if (ar > tw / th) { bw = tw; bh = tw / ar; } else { bh = th; bw = th * ar; }
        var ox = (tw - bw) / 2, oy = (th - bh) / 2;
        P.forEach(function (p) {
          var i = document.createElement('i');
          i.style.left = (ox + (p.x / aW) * bw) + 'px';
          i.style.top = (oy + (p.y / aH) * bh) + 'px';
          i.style.width = Math.max(2, (p.w / aW) * bw - 1) + 'px';
          i.style.height = Math.max(2, (p.h / aH) * bh - 1) + 'px';
          box.appendChild(i);
        });
      });
      return true;
    }
    if (!drawLayoutTiles()) {
      window.addEventListener('load', drawLayoutTiles);
      setTimeout(drawLayoutTiles, 600);
      setTimeout(drawLayoutTiles, 2000);
    }

    // initial paint: price, promo maths, disabled states
    apply();
    }
    window.tiaBuyBoxInit = init;
    /* The band (price + button) renders after this script's parse position — an init
       before DOMContentLoaded would resolve those nodes to null and the price would
       never fill. */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
